import {
  IconButton,
  Modal,
  Paper,
  Tooltip,
  Box,
  Badge,
  Avatar,
  Typography,
  Button,
  TextField,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
} from "@mui/material";
import { Stack, useTheme } from "@mui/system";
import Resizer from "react-image-file-resizer";
import useStyles from "./styles";
import api from "../../../../../../services/api";
import { AddAPhoto, Person, PersonOff } from "@mui/icons-material";
import { useEffect, useState } from "react";
import usePermissoesDoCliente from "../hooks/usePermissoesDoCliente";
import { getClienteOptionLabel } from "../../../../../../components/grupoEconomico/helpers";
import VirtualizedAutocomplete from "../../../../../../components/virtualization/virtualizedAutocomplete";

// Permissão global do sistema, existe em todos os clientes
const PERMISSAO_ADM = "ADM";

export default function ModalEditUserCliente({
  openModalEditUser,
  setOpenModalEditUser = () => {},
  selectedRow,
  setUserEdit = () => {},
  userEdit,
  setSnackbar = () => {},
  setUserCliente = () => {},
  userCliente,
  allClientes,
}) {
  const [Null, setNull] = useState(false);
  const [codigoPermissao, setCodigoPermissao] = useState("");
  const [disableSaveButtom, setDisableSaveButtom] = useState(false);
  const [emailValido, setEmailValido] = useState(false);
  const [selectCliente, setSelectCliente] = useState({});
  const theme = useTheme();
  const styles = useStyles(theme);

  // As permissões do portal são por cliente: a lista acompanha o cliente selecionado
  const { permissoes } = usePermissoesDoCliente({
    clienteId: selectCliente?.id,
    enabled: openModalEditUser,
  });

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  useEffect(() => {
    setUserEdit({
      id: selectedRow?.id,
      nome: selectedRow?.nome,
      sobrenome: selectedRow?.sobrenome,
      login: selectedRow?.login,
      email: selectedRow?.email,
      status: selectedRow?.status,
      foto: selectedRow?.foto,
      cliente: selectedRow?.cliente,
    });
    // O backend já devolve a permissão do usuário junto com a linha
    setCodigoPermissao(
      selectedRow?.permissoes?.permissao?.codigoPermissao || "",
    );
    setSelectCliente(selectedRow?.cliente);
  }, [selectedRow]);

  // Ao trocar o cliente, a permissão anterior pode não existir no novo cliente.
  // O default passa a ser ADM, que é global e existe para todos os clientes.
  useEffect(() => {
    if (!permissoes?.length) return;

    const permissaoAindaValida = permissoes.some(
      (permissao) => permissao?.codigoPermissao === codigoPermissao,
    );

    if (!permissaoAindaValida) {
      setCodigoPermissao(PERMISSAO_ADM);
    }
  }, [permissoes]);

  useEffect(() => {
    if (emailRegex.test(userEdit?.email)) {
      setEmailValido(true);
    } else {
      setEmailValido(false);
    }
  }, [userEdit?.email]);

  const handleUpdateCliente = () => {
    if (!userEdit?.login || !emailValido) {
      setSnackbar({
        children: "Necessário informar login e e-mail",
        severity: "error",
      });
      setNull(true);
    } else {
      updateUserCliente();
    }
  };

  const updateUserCliente = async () => {
    setDisableSaveButtom(true);
    try {
      let permissaoSelect = permissoes.filter(
        (permissao) => permissao?.codigoPermissao === codigoPermissao,
      );
      let clienteSelect = allClientes.filter(
        (cliente) => cliente?.id === selectCliente?.id,
      );

      const response = await api.post("/interno/editUserCliente", {
        usuarioId: userEdit?.id,
        nome: userEdit?.nome,
        sobrenome: userEdit?.sobrenome,
        login: userEdit?.login,
        email: userEdit?.email,
        status: userEdit?.status,
        foto: userEdit?.foto,
        clienteId: (Array.isArray(clienteSelect) && clienteSelect[0]?.id) || "",
        permissao: (Array.isArray(permissaoSelect) && {
          permissaoId: permissaoSelect[0]?.id || "",
          usuarioId: userEdit?.id,
        }) || {
          permissaoId: selectedRow?.permissoes?.permissaoId,
          usuarioId: userEdit?.id,
        },
      });
      setSnackbar({
        children: "Perfil atualizado com sucesso",
        severity: "success",
      });

      const userFilter = userCliente?.filter(
        (user) => user?.id === userEdit?.id,
      );
      let objetoUserClient = userFilter[0];

      objetoUserClient = {
        ...objetoUserClient,
        login: userEdit?.login,
        email: userEdit?.email,
        nome: userEdit?.nome,
        sobrenome: userEdit?.sobrenome,
        status: userEdit?.status,
        foto: userEdit?.foto,
        cliente: Array.isArray(clienteSelect) && {
          id: clienteSelect[0]?.id || "",
          nome: clienteSelect[0]?.nome,
          clienteErpId: clienteSelect[0]?.clienteErpId,
          isGrupoEconomico: clienteSelect[0]?.isGrupoEconomico,
        },
        permissoes: (Array.isArray(permissaoSelect) &&
          permissaoSelect[0] && {
            permissaoId: permissaoSelect[0]?.id,
            usuarioId: userEdit?.id,
            // Sem isso o grid mostrava "SEM PERMISSÃO" até um refetch: o
            // renderCell lê justamente este objeto aninhado, não o permissaoId
            permissao: {
              id: permissaoSelect[0]?.id,
              codigoPermissao: permissaoSelect[0]?.codigoPermissao,
              color: permissaoSelect[0]?.color,
            },
          }) || {
          permissaoId: selectedRow?.permissoes?.permissaoId,
          usuarioId: userEdit?.id,
          permissao: selectedRow?.permissoes?.permissao,
        },
      };
      const newDataUserClient = userCliente?.filter(
        (user) => user?.id !== userEdit?.id,
      );
      newDataUserClient.push(objetoUserClient);
      setUserCliente(newDataUserClient);
      handleClose();
    } catch (error) {
      let dataError = error?.response?.data;

      if (dataError) {
        if (dataError === "Email já existente") {
          setSnackbar({
            children: "E-mail existente",
            severity: "error",
          });
        } else if (dataError === "Login já existente") {
          setSnackbar({
            children: "Login existente",
            severity: "error",
          });
        } else {
          setSnackbar({
            children: "Erro ao atualizar informações do perfil",
            severity: "error",
          });
        }
      } else {
        setSnackbar({
          children: "Erro ao atualizar informações do perfil",
          severity: "error",
        });
      }
    } finally {
      setDisableSaveButtom(false);
    }
  };

  const handleClose = () => {
    setOpenModalEditUser(false);
    setNull(false);

    setUserEdit({
      id: selectedRow?.id,
      nome: selectedRow?.nome,
      sobrenome: selectedRow?.sobrenome,
      login: selectedRow?.login,
      email: selectedRow?.email,
      status: selectedRow?.status,
      foto: selectedRow?.foto,
      cliente: selectedRow?.cliente,
    });
    setCodigoPermissao(
      selectedRow?.permissoes?.permissao?.codigoPermissao || "",
    );
    setSelectCliente(selectedRow?.cliente);
  };

  return (
    <Modal
      sx={styles.containerModal}
      open={openModalEditUser}
      onClose={handleClose}
    >
      <Paper sx={styles.container}>
        <Stack sx={styles.StackFoto}>
          <Box sx={styles.BoxAvatar}>
            <Badge
              overlap="circular"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              badgeContent={
                <Tooltip title={"adicionar imagem"}>
                  <IconButton
                    disabled={disableSaveButtom}
                    variant="outlined"
                    component="label"
                    color="primary"
                    sx={styles.containerIconButton}
                  >
                    <AddAPhoto />
                    <input
                      hidden
                      accept=".png, .jpg, .jpeg"
                      type="file"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file?.size < 1024 * 1000) {
                          Resizer.imageFileResizer(
                            file,
                            500,
                            500,
                            "JPEG",
                            80,
                            0,
                            (uri) => {
                              setUserEdit((prev) => ({ ...prev, foto: uri }));
                            },
                            "base64",
                            500,
                            500,
                          );
                          const fileReader = new FileReader();
                          fileReader.readAsDataURL(file);
                          fileReader.onload = () => {};
                          fileReader.onerror = (error) => {
                            console.error("Error:", error);
                          };
                        } else {
                          setSnackbar({
                            children: "Tamanho máximo 1MB",
                            severity: "error",
                          });
                        }
                      }}
                    />
                  </IconButton>
                </Tooltip>
              }
            >
              <Avatar
                src={userEdit?.foto}
                color="secondary"
                sx={styles.Avatar}
              />
            </Badge>
          </Box>
        </Stack>
        <Box sx={styles.boxAreaModalPerfil}>
          <Box sx={styles.boxAreaTituloModalPerfil}>
            <Typography color={theme.palette.white.main} variant="title">
              Perfil
            </Typography>
          </Box>
          <Box sx={styles.boxAreaConteudoModalPerfil}>
            <Stack spacing={1} direction="column" width={"100%"} marginTop={5}>
              <TextField
                variant="filled"
                label="Nome"
                size="small"
                value={userEdit?.nome}
                disabled={disableSaveButtom}
                sx={styles.TextField}
                onChange={(e) =>
                  setUserEdit((prev) => ({ ...prev, nome: e.target.value }))
                }
              />

              <TextField
                variant="filled"
                label="Sobrenome"
                size="small"
                value={userEdit?.sobrenome}
                disabled={disableSaveButtom}
                sx={styles.TextField}
                onChange={(e) =>
                  setUserEdit((prev) => ({
                    ...prev,
                    sobrenome: e.target.value,
                  }))
                }
              />
            </Stack>
            <Divider orientation="horizontal" sx={styles.divider} />
            <Stack spacing={1} direction="column" width={"100%"}>
              <TextField
                variant="filled"
                label="Login"
                size="small"
                value={userEdit?.login}
                disabled={disableSaveButtom}
                sx={styles.TextField}
                onChange={(e) =>
                  setUserEdit((prev) => ({
                    ...prev,
                    login: e.target.value,
                  }))
                }
                helperText={
                  !userEdit?.login && Null ? "Necessário informar um login" : ""
                }
                error={!userEdit?.login && Null}
              />

              <TextField
                variant="filled"
                label="E-mail"
                size="small"
                disabled={disableSaveButtom}
                value={userEdit?.email}
                sx={styles.TextField}
                onChange={(e) =>
                  setUserEdit((prev) => ({
                    ...prev,
                    email: e.target.value,
                  }))
                }
                helperText={
                  (!userEdit?.email || !emailValido) && Null
                    ? "E-mail válido"
                    : ""
                }
                error={(!userEdit?.email || !emailValido) && Null}
              />
            </Stack>
            <Divider orientation="horizontal" sx={styles.divider} />

            <Stack spacing={1} direction="row" sx={{ width: "100%" }}>
              <FormControl
                variant="filled"
                size="small"
                sx={styles.TextField}
                fullWidth
                disabled={disableSaveButtom}
              >
                <InputLabel>Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  value={!userEdit?.status ? "DESATIVADO" : "ATIVO"}
                  onChange={(e) => {
                    setUserEdit((prev) => ({
                      ...prev,
                      status: e.target.value === "DESATIVADO" ? 0 : 1,
                    }));
                  }}
                  name="status"
                  color="primary"
                >
                  <MenuItem value={"ATIVO"}>
                    <Box sx={styles.boxStatusItem}>
                      <Person
                        sx={{ color: theme.palette.chip.colorText.success }}
                      />
                      <Typography>ATIVO</Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem value={"DESATIVADO"}>
                    <Box sx={styles.boxStatusItem}>
                      <PersonOff
                        sx={{ color: theme.palette.chip.colorText.critical }}
                      />
                      <Typography>DESATIVADO</Typography>
                    </Box>
                  </MenuItem>
                </Select>
              </FormControl>
              <FormControl
                variant="filled"
                size="small"
                sx={styles.TextField}
                fullWidth
                disabled={disableSaveButtom}
              >
                <InputLabel>Permissão</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  value={codigoPermissao || ""}
                  label="Permissão"
                  onChange={(event) => {
                    setCodigoPermissao(event.target.value);
                  }}
                  renderValue={(selected) => {
                    const permissaoSelecionada = permissoes?.find(
                      (permissao) => permissao?.codigoPermissao === selected,
                    );
                    return (
                      <Chip
                        label={selected?.toUpperCase()}
                        size="small"
                        sx={{
                          fontWeight: "bold",
                          color: theme.palette.white.main,
                          backgroundColor:
                            permissaoSelecionada?.color ||
                            "chip.main.waitingReview",
                        }}
                      />
                    );
                  }}
                  name="status"
                  color="primary"
                >
                  {Array.isArray(permissoes) &&
                    permissoes?.map((permissao) => (
                      <MenuItem
                        key={permissao?.id}
                        value={permissao?.codigoPermissao}
                      >
                        <Chip
                          label={permissao?.codigoPermissao?.toUpperCase()}
                          size="small"
                          sx={{
                            fontWeight: "bold",
                            color: theme.palette.white.main,
                            backgroundColor:
                              permissao?.color || "chip.main.waitingReview",
                          }}
                        />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Stack>
            <Divider orientation="horizontal" sx={styles.divider} />
            <Stack spacing={1} sx={styles.stackCliente} direction="row">
              <VirtualizedAutocomplete
                variant="filled"
                size="small"
                fullWidth
                disabled={disableSaveButtom}
                disablePortal
                value={selectCliente}
                sx={styles.TextField}
                options={allClientes}
                getOptionLabel={(option) => getClienteOptionLabel(option)}
                onChange={(event, cliente) => {
                  setSelectCliente(cliente);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Cliente" variant="filled" />
                )}
              />
            </Stack>

            <Box sx={styles.boxAreaButtomModalPerfil}>
              <Box sx={styles.containerButtonSalvar}>
                <Button
                  onClick={handleClose}
                  sx={{
                    ...styles.button,
                    color: theme.palette.text.main,
                  }}
                  variant="outlined"
                  size="large"
                  disabled={disableSaveButtom}
                >
                  Cancelar
                </Button>
                <Button
                  disabled={disableSaveButtom}
                  onClick={handleUpdateCliente}
                  sx={styles.button}
                  variant="contained"
                  size="large"
                >
                  Salvar
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Modal>
  );
}
